import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const isBenignResizeObserverError = (message = "") => (
  message.includes("ResizeObserver loop limit exceeded")
  || message.includes("ResizeObserver loop completed with undelivered notifications")
);

window.addEventListener("error", (event) => {
  if (!isBenignResizeObserverError(event.message)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
